import { createActions, createReducer } from 'reduxsauce'

import ConsultaAtaRegistroPrecoService from '../../servicos/ConsultaAtaRegistroPrecoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaAtaRegistroPrecoInicio: [],
    buscaConsultaAtaRegistroPrecoErro: ['erro'],
    buscaConsultaAtaRegistroPrecoSucesso: ['consultaAtaRegistroPreco'],
    limpar: [],
    setConsultaAtaRegistroPrecoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaAtaRegistroPreco = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaAtaRegistroPrecoInicio())
        let serv = new ConsultaAtaRegistroPrecoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaAtaRegistroPrecoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaAtaRegistroPrecoErro(error)))
    }
}

const buscaConsultaAtaRegistroPrecoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaAtaRegistroPrecoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaAtaRegistroPrecoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaAtaRegistroPreco.resultado,
        dataSincronizacaoDados: action.consultaAtaRegistroPreco.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaAtaRegistroPrecoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ATA_REGISTRO_PRECO_INICIO]: buscaConsultaAtaRegistroPrecoInicio,
    [Types.BUSCA_CONSULTA_ATA_REGISTRO_PRECO_ERRO]: buscaConsultaAtaRegistroPrecoErro,
    [Types.BUSCA_CONSULTA_ATA_REGISTRO_PRECO_SUCESSO]: buscaConsultaAtaRegistroPrecoSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_ATA_REGISTRO_PRECO_ESTADO_DT]: setConsultaAtaRegistroPrecoEstadoDT,
})
